import { Course } from './course.model';

export interface CourseState {
    list: Course[];
}

export const initialCourseState: CourseState = {
    list: new Array()
};